<template>
    <el-dialog title="支付" :visible.sync="visible" :before-close="done=>done()" :close-on-click-modal="false">
        <div class="userInfo">
            
            <img v-if="avatar" :src="avatar" alt="">
            <div v-else class="avatar"></div>
            
            <div>
                <b>{{ db.userName }}</b>
                <p>请用户注意账户安全，谨防上当受骗！</p>
            </div>
        </div>
        <div class="payInfo">
            <div>{{ db.userName }}</div>
            <div>{{ db.number }}</div>
            <div>{{ db.target }}</div>
            <div>{{ db.achievment }}</div>
        </div>
        <div class="payBtn">{{ db.coin }}缩币</div>
        <div class="confirmBtn">
            <label> <input type="checkbox" v-model="checkbox"/> 同意 <span
                @click="xy_isShow=true">《缩水师网支付协议》</span> </label>
            <el-button type="primary" @click="handleSubmit">立即支付</el-button>
        </div>
        
        <el-dialog title="缩水网支付协议"
                   :visible.sync="xy_isShow"
                   width="60%"
                   center
                   append-to-body
        >
            <div>
                <p> 1、 缩水网的某些服务是以收费方式提供的。一旦凭个人账户密码通过个人帐户查阅和下载收费服务，将视为是您本人查阅和下载收费服务，您应按有关的收费标准、付款方式支付相关服务费及其他费用。资费说明标明在
                    缩水网网站相应服务的相应页面上。</p>
                <p> 2 、付费标准：服务费之标准应按潜江市晖喆商务信息服务部或合作公司关于付费标准规定办理。</p>
                <p> 3、依本服务条款所取得的服务权利不可转让。</p>
                <p> 4、遵守国家的有关法律、法规和行政规章制度。相关法律、法规和制度包括但不限于下列链接所提供的内容：</p>
                <p>
                    5、潜江市晖喆商务信息服务部对其发行的或与合作公司共同发行的包括但不限于产品或服务的全部内容及缩水网网站上的材料拥有版权等知识产权，受法律保护。</p>
                <p>
                    6、未经潜江市晖喆商务信息服务部书面许可，任何单位及个人不得以任何方式或理由对上述产品、服务、信息、材料的任何部分进行使用、复制、修改、抄录、传播或与其它产品捆绑使用、销售。</p>
                <p> 7、每项服务的内容、收费标准、收费方式、服务费及服务条款应以最后发布的通知为准。</p>
                <p> 8、凡侵犯本企业版权等知识产权的，本企业必依法追究其法律责任。</p>
                <p> 9、本企业法律事务部受本公司指示，特此郑重法律声明！</p>
                <p> 10、
                    如用户违反国家法律法规或本服务条款，本企业和合作公司将有权停止向用户提供服务而不需承担任何责任，如导致缩水网或合作公司遭受任何损害或遭受任何来自第三方的纠纷、诉讼、索赔要求等，用户须向本企业或合作公司赔偿相应的损失，用户并需对其违反服务条款所产生的一切后果负全部法律责任。</p>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
import {getSkillerUserinfo} from "@/api/swdgw"

export default {
    name: 'popupPay',
    data() {
        return {
            visible: false,
            db: {},
            payParams: {},
            
            checkbox: false,
            
            xy_isShow: false,
            
            avatar:'',
        }
    },
    methods: {
        init(payParams, db) {
            console.log('init', JSON.parse(JSON.stringify(db)));
            this.visible = true;
            this.checkbox = false;
            this.db = db
            this.payParams = payParams
            
            getSkillerUserinfo(db.createUser).then(res => this.avatar = res.data.avatar)
        },
        handleSubmit() {
            if (!this.checkbox) {
                this.$message.error('请同意《缩水师网支付协议》');
                return;
            }
            this.$emit('submit', this.payParams, this.db)
            this.visible = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.userInfo {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    img,.avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 10px;
        background-color: #878787;
    }
    
    div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-left: 10px;
        
        b {
            font-size: 18px;
            color: #333;
        }
        
        p {
            margin: 0;
            font-size: 12px;
            color: #fb9696;
        }
    }
}

.payInfo {
    display: flex;
    justify-content: space-between;
    text-align: center;
    border: 2px solid #aeaeae;
    margin: 30px 0 20px;
    border-radius: 10px;
    font-weight: bold;
    
    > div {
        flex: 1;
        height: 40px;
        line-height: 40px;
    }
}

.payBtn {
    width: 130px;
    height: 35px;
    line-height: 35px;
    background-color: #f4bb0b;
    color: #fff;
    font-weight: bold;
    text-align: center;
    border-radius: 10px;
    margin: auto;
    cursor: pointer;
    transition: filter 0.3s ease;
    
    &:hover {
        filter: brightness(0.9);
    }
}

.confirmBtn {
    user-select: none;
    width: 80%;
    margin: 30px auto 0;
    
    label {
        display: flex;
        align-items: center;
        
        a, span {
            color: #65a9f6;
            text-decoration: none;
        }
    }
    
    .el-button {
        width: 100%;
        margin-top: 10px;
    }
}
</style>
